import React, { useState } from "react";

import { MenuButton } from "../../BaseComponents/Button/MenuButton";
import {
	MenuItemWrapper,
	MenuItemText,
	CollapsableMenuItem,
	MenuButtonWrapper,
	ItemLink,
	IconWrapper,
	Arrow,
	Icon,
} from "./MenuComponents";
import { TransitionGroup, CSSTransition } from "react-transition-group";

const MenuItem = ({
	Name,
	Url,
	Depth,
	Children = [],
	IsActive,
	IsExpanded,
	Display,
	Icon: img,
}) => {
	const [expanded, setExpanded] = useState(IsExpanded);
	const [timesOpen, setTimesOpen] = useState(0);
	const handleClick = (e) => {
		setTimesOpen(timesOpen + 1);
		setExpanded((prevValue) => !prevValue);
	};
	return (
		<CollapsableMenuItem IsExpanded={expanded} Depth={Depth} Display={Display}>
			<MenuItemWrapper IsExpanded={expanded} IsActive={IsActive} Depth={Depth}>
				<ItemLink Depth={Depth} href={Url}>
					<IconWrapper show={Depth == 1}>
						<Icon className={img} />
					</IconWrapper>
					<MenuItemText IsActive={IsActive} Depth={Depth} IsExpanded={expanded}>
						{Name}
					</MenuItemText>
				</ItemLink>
				{Children.length > 0 && (
					<MenuButtonWrapper>
						<MenuButton
							onClick={(e) => handleClick(e)}
							Width="30px"
							Depth={Depth}
							IsExpanded={expanded}
							ShouldAnimate={timesOpen > 0}
						/>
					</MenuButtonWrapper>
				)}
			</MenuItemWrapper>
			{Depth == 1 && <Arrow show={expanded && Children.length > 0}></Arrow>}

			<TransitionGroup>
				{expanded &&
					Children.map((subItem, index) => {
						if (timesOpen > 0) {
							subItem.IsExpanded = false;
						}
						return (
							<CSSTransition
								key={`${timesOpen}${index}${Name}`}
								timeout={{ enter: 300, appear: 300, exit: 300 }}
								classNames="fade"
								in={expanded}
							>
								<MenuItem
									Display={expanded}
									Depth={Depth + 1}
									{...subItem}
									index={index}
								></MenuItem>
							</CSSTransition>
						);
					})}
			</TransitionGroup>
		</CollapsableMenuItem>
	);
};
export default MenuItem;
